const siteConfig = {
  brandName: "purelattice",
  displayName: "purelattice",
  logo: "/head/purelattice-mark.svg",
  description:
    "Thoughtful stationery and journaling pieces for slower, more meaningful everyday rituals.",
  siteUrl: window.location.origin,
  locale: "en-US",
  currency: "USD",
  currencySymbol: "$",
  contact: {
    email: "assist@purelattice.online",
    responseTime: "within two working days",
    location: "Hong Kong",
  },
  shipping: {
    flatRate: 9.99,
    freeThreshold: null,
    dispatchTime: "1–2 working days",
    deliveryEstimate: "2–6 working days",
  },
};

export const formatPrice = (amount) => {
  const numericAmount = Number(amount) || 0;
  return `${siteConfig.currencySymbol}${new Intl.NumberFormat(siteConfig.locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericAmount)}`;
};

export default siteConfig;
